import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import { getToken } from "../../utils/localStorageMethods";
import { PraentSlice } from "./school/PraentSlice";
import { driversSlice } from "./vendor/driversSlice";

const apiUrl = config.Url;

export const authSlice = createApi({
  reducerPath: "authSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: `${apiUrl}`,
    credentials: "include",
    prepareHeaders: (headers) => {
      const token = getToken(); // Get token from cookies
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    authUser: builder.mutation({
      query: ({ user, endPoint }) => ({
        url: `${endPoint}`,
        method: "POST",
        body: user,
      }),
      async onQueryStarted({ invalidate }, { dispatch, queryFulfilled }) {
        try {
          // wait for success
          await queryFulfilled;
          // invalidate ONLY if provided
          if (!invalidate) return;
          if (invalidate === "parents") {
            dispatch(PraentSlice.util.invalidateTags(["parents"]));
          }
          if (invalidate === "drivers") {
            dispatch(driversSlice.util.invalidateTags(["drivers"]));
          }
        } catch (err) {
          // ❌ no invalidate on error
        }
      },
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: "auth/forgot-password",
        method: "POST",
        body: data,
      }),
    }),
    // VERIFY OTP API (FOR ALL USERS)
    verifyOTP: builder.mutation({
      query: (data) => ({
        url: "auth/verify-otp",
        method: "POST",
        body: data,
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: "auth/reset-password",
        method: "POST",
        body: data,
      }),
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        url: "auth/change-password",
        method: "POST",
        body: data,
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: "auth/logout",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useAuthUserMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useVerifyOTPMutation,
  useLogoutMutation,
} = authSlice;
